/**
 * Sentry `beforeSend` hook.
 *
 * Synthetic, untrusted promise rejections — e.g. a `CustomEvent` dispatched by a browser
 * extension (`isTrusted: false`) rather than a real `Error` — are captured as
 * "Event `CustomEvent` (type=unhandledrejection)" with no stack trace and are not
 * actionable. Drop them rather than reporting noise (MYEVENT-QUOTE-8). Everything else,
 * including real `Error` rejections, is reported unchanged.
 *
 * @param {object} event the Sentry event about to be sent
 * @param {object} [hint] Sentry hint; `hint.originalException` is the rejected value
 * @returns {object|null} `null` to drop the event, otherwise the event unchanged
 */
export function dropUntrustedEventRejections(event, hint) {
  const original = hint && hint.originalException;

  const isSyntheticEvent =
    original &&
    typeof original === 'object' &&
    !(original instanceof Error) &&
    original.isTrusted === false &&
    typeof original.type === 'string';

  return isSyntheticEvent ? null : event;
}
